import React from 'react'
import { Route, Switch, useLocation } from 'react-router'

import type { DrawerProps } from '../../../../../../ui/components'
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
} from '../../../../../../ui/components'
import { TransferCartContent } from './TransferCartContent'
import { OptionsContent } from './OptionsContent'
import { ShareCartContent } from './ShareCartContent'
import { SalesAssociateCodeContent } from './SalesAssociateCodeContent'
import { CheckoutRoute } from '../../../../constants'

export type OptionsDrawerProps = {
  onSubmit?: (coupon: string) => void
} & Omit<DrawerProps, 'onSubmit'>

export const OptionsDrawer = ({ onSubmit, ...props }: OptionsDrawerProps) => {
  const location = useLocation()

  return (
    <Drawer {...props} data-testid="options-drawer">
      <DrawerCloseButton />
      <DrawerBody>
        <Switch>
          <Route path={CheckoutRoute.CartOptionsDrawer} exact>
            <OptionsContent />
          </Route>
          <Route path={CheckoutRoute.CartOptionShareDrawer}>
            <ShareCartContent />
          </Route>
          <Route path={CheckoutRoute.CartOptionCodeDrawer}>
            <SalesAssociateCodeContent
              isOpen={location.pathname.includes('code')}
            />
          </Route>
          <Route path={CheckoutRoute.CartOptionTransferDrawer}>
            <TransferCartContent />
          </Route>
        </Switch>
      </DrawerBody>
    </Drawer>
  )
}
